export enum LocalStorageKeys {
  AccessToken = 'access_token',
  Code = 'code',
}
